import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "appRedux/hooks"
import { useEditWishListMutation } from "appRedux/slices/wishListApiSlice"
import { useAuth } from "context/AuthContext"
import WishListForm from "components/templates/WishListForm"

export default function EditListPage() {
  const currentPageInfo = useAppSelector((state) => state.global.currentPageInfo)
  const userProfile = useAppSelector((state) => state.user.profile)

  const [editWishList, editWishListResult] = useEditWishListMutation()

  const { user } = useAuth()

  const navigate = useNavigate()

  useEffect(() => {
    if (editWishListResult.status === "fulfilled") {
      handleWishListEditedSuccessfully()
    }
  }, [editWishListResult])

  useEffect(() => {
    if (editWishListResult.status === "fulfilled") {
    }
  }, [userProfile])

  function handleWishListEditedSuccessfully() {
    navigate(`/user/${user?.handle}`, { replace: true })
  }

  function isCTADisabled(dirtyFields: object) {
    return Object.keys(dirtyFields).length === 0 || editWishListResult.isLoading
  }

  function handleEditList(value: WishListRequestPayload) {
    if (!currentPageInfo?.dynamicPathParts) return
    editWishList({
      id: currentPageInfo?.dynamicPathParts?.listId,
      ...value
    })
  }

  return (
    <WishListForm
      isCTADisabled={isCTADisabled}
      isCTALoading={() => editWishListResult.isLoading}
      onSubmit={handleEditList}
    />
  )
}
